import classNames from 'classnames';
import React from 'react';
import { MarkerDisplaySize } from 'types/location.js';

export const PillV2Label = ({
  label,
  selected,
  mockHover,
  children,
  displaySize,
}: {
  label?: string;
  displaySize?: MarkerDisplaySize;
  selected?: boolean;
  children?: React.ReactNode;
  // used for testing
  mockHover?: boolean;
}) => {
  const coreStyle = { zIndex: -1 };
  const pillLabelOffset = 24; // so that the label button radius overlaps the pill
  const markerLabelPadding = 8;
  const style =
    // isLabelRight
    // ? {
    //     ...coreStyle,
    //     right: `-${styleOffset}px`,
    //     paddingRight: `${styleOffset + markerLabelOffset}px`,
    //   }
    // :
    { ...coreStyle, left: `-${pillLabelOffset}px`, paddingLeft: `${pillLabelOffset + markerLabelPadding}px` };

  return (
    <div
      data-comp="pill-dynamic-label"
      className={classNames('u-posRel pill-v2--hover-display', {
        'u-displayInherit': displaySize === MarkerDisplaySize.Large || selected || mockHover,
      })}
    >
      <div
        className={classNames(
          'u-flex u-flexAlignItemsCenter u-posAbs pill--label-padding border-radius-md pill--label-bg',
          {
            'pill--label-bg-displayLarge': displaySize === MarkerDisplaySize.Large,
            'pill--label-bg-selected': selected,
            'pill--label-bg-hover': mockHover,
          },
        )}
        style={style}
      >
        {label && (
          <div className="u-flex u-flexAlignItemsCenter" style={{ height: '24px' }}>
            <span className="u-textNoWrap u-text-sm u-textBold">{label}</span>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
